import React, {useState} from "react"

import {PageContentInterface} from "../page-content-interface"
import AppControlMore from "../../../../../layout/app-controls/buttons/more/more"
import CoverSelector from "../../../../../core/gd-components/cover/cover-selector/control-button"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"
import page_setCover from "../../actions/set-cover"
import AppControlPreferences from "../../../../../layout/app-controls/buttons/preferences/preferences-new"
import PagePreferences from "../preferences/preferences"

import AppControlShare from "../../../../../layout/app-controls/buttons/share/share"
import {MoreButtonOptionType} from "../../../../../layout/app-controls/buttons/more/standard-option"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard"

type Props = {
    app             : PageContentInterface

    attachments?    : AttachmentsCollection

    onAddPage       : func
}

const debug = false
// const debug = "PageControls"

export default function PageControls(props:Props) {

    const [isPopoverShown, setIsPopoverShown] = useState(false)

    const onTogglePopover = (value: boolean) => {
        setIsPopoverShown(value)
    }

    const onCoverSelected = (cover: any) => {
        debug && console.log(debug, 'onCoverSelected', cover)
        page_setCover(cover)
    }

    const project = gd.session.projects.get(props.app.projectId)!

    const viewMoreOptions = [
        {
            type    : MoreButtonOptionType.HELP,
            onClick : ()=>{gd.utils.openHelp('article.text.editor')}
        },
        {
            type    : MoreButtonOptionType.SHORTCUTS,
            onClick : ()=>{gd.utils.openHelp('article.text.editor.shortcuts')}
        }
    ]

    const classes = Classes("page-controls flex-row-left-center h-30", {
        'popover-shown': isPopoverShown
    })

    return (
        <div className={classes}>
            <ControlButtonStandard className    = "m-r-8"
                                   type         = {ControlButtonType.ADD_PAGE}
                                   hint         = 'Add page'
                                   isDisabled   = {!project.acl.canAddPage}
                                   onClick      = {props.onAddPage}/>

            {project.acl.canModifyViews &&
                <AppControlPreferences app                  = {props.app}
                                       iconOnly             = {true}
                                       preferencesComponent = {PagePreferences}/>}

            <div className="separator"/>

            <CoverSelector enableAttachments    = {true}
                           className            = "m-r-8"
                           attachments          = {props.attachments}
                           disabled             = {!project.acl.canEditCover}
                           onSelect             = {onCoverSelected}
                           onTogglePopover      = {onTogglePopover}/>

            <AppControlShare className  = "m-r-8"
                             app        = {props.app}/>

            <AppControlMore options         = {viewMoreOptions}
                            onTogglePopover = {onTogglePopover}/>
        </div>
    )
}